import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = user
  const [progress, setProgress] = useState({ percent: 0, modules_completed: [], weekend_steps_completed: [] });

  const loadUser = useCallback(async () => {
    const token = localStorage.getItem("waos_token");
    if (!token) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("waos_token");
      setUser(false);
    }
  }, []);

  const refreshProgress = useCallback(async () => {
    try {
      const { data } = await api.get("/progress");
      setProgress(data);
    } catch {}
  }, []);

  useEffect(() => { loadUser(); }, [loadUser]);
  useEffect(() => { if (user && user.id) refreshProgress(); }, [user, refreshProgress]);

  const setSession = (data) => {
    if (data.access_token) localStorage.setItem("waos_token", data.access_token);
    setUser(data.user);
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("waos_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, setSession, logout, progress, refreshProgress }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
